import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { FAV_LOGO_URL } from "../services/config";
import { getSiteFavicon } from "../services/setting";

const BrandingContext = createContext({ favLogo: FAV_LOGO_URL });

export const useBranding = () => useContext(BrandingContext);

const setTabIcon = (href) => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.removeAttribute("type"); // the new icon may be png/svg/ico
  link.href = href;
};

// Favicon is dynamic: the backend `site-favicon` setting wins, otherwise the
// REACT_APP_FAV_LOGO env URL (also what index.html ships with) stays in place.
// The same URL feeds the collapsed-sidebar icon via useBranding().
export const BrandingProvider = ({ children }) => {
  const [favLogo, setFavLogo] = useState(FAV_LOGO_URL);

  useEffect(() => {
    let ignore = false;
    getSiteFavicon().then((url) => {
      if (!ignore && url) setFavLogo(url);
    });
    return () => {
      ignore = true;
    };
  }, []);

  useEffect(() => {
    setTabIcon(favLogo);
  }, [favLogo]);

  const value = useMemo(() => ({ favLogo }), [favLogo]);

  return (
    <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>
  );
};
